import { HTTP_URL_RE } from './HTTP_URL_RE';

export const isHttpUrl = (url: string): boolean => HTTP_URL_RE.test(url.trim());
